import { MessageModel, PaidMessageModel } from '$store/models';
import { useMemo } from 'react';
import { format } from '$utils';

export type PreparedHistoryItem = {
  type: string;
  object: MessageModel | PaidMessageModel | number;
  key: string | number;
};

export const usePreparedHistory = (messages: MessageModel[] | PaidMessageModel[]) => {
  return useMemo(() => {
    const messagesCopy = [...messages];
    messagesCopy.sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1));

    const result: PreparedHistoryItem[] = [];

    let lastDate = '';
    for (let message of messagesCopy) {
      const createdAt = message.createdAt * 1000;
      const date = format(createdAt, 'dd MMMM yyyy');
      if (date !== lastDate) {
        result.push({
          type: 'date',
          key: date,
          object: createdAt,
        });
        lastDate = date;
      }

      result.push({
        type: 'message',
        key: message.id,
        object: message,
      });
    }

    return result;
  }, [messages]);
};
